import jQuery from 'jquery';
let $ = jQuery;

/**
    * class HSN.ExchangeVariantSelector
    *
    * Progressively enhances a definition list full of option radio buttons and
    * labels to be more interactive.
    **/
HSN.ExchangeVariantSelector = function (config) {
    /**
        * new HSN.ExchangeVariantSelector(config)
        * - config (Object): A configuration object for the [[HSN.ExchangeVariantSelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the BuySelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector
        *     that will ultimately resolve to an HTML element will act as the container for the set of options.
        **/

    var __scope = this;

    var _flyouts = [];

    this._application = config.application;

    this._container = $('.new-item-details');
    this.__varSelections = [];
        
    this._preSelectedWebId = $('.pre_selected_webid', __scope._container).val();
    this._isPlusSizeVariantSelected = false;

    var variantJsonString = $('#json-variants').html();
    this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;

    this._preselectedVariant = $.grep(__scope._variants, function (v) {
        return v.Sku == __scope._preSelectedWebId;
    })[0];

    this._imageContainer = $('#new-prod-image');

    var tabs = new HSN.TabPanel($('.product-option-selector', __scope._container),
        '.variant-group-tab-items a',
        null,
        false
    );

    this.init = function () {
        this._container.addClass('product-option-selector');//TODO remove?

        this.SynchronizeOptionLabels();

        var waitlistFlyout = $('<div class="flyout-container"><div class="variant-waitlist flyout"><div class="variant-flyout-header">On Waitlist</div></div></div>');
        var soldoutFlyout = $('<div class="flyout-container"><div class="variant-soldout flyout"><div class="variant-flyout-header">Sold Out</div></div></div>');

        //ignore hover events used for product option preview on touch devices
        if (!Modernizr.touchevents) {
            this._container.on('mouseenter', 'dd label', function (e) {
                var $label = $(this);
                var $input = $('input', this);
                if (!$input.length) {
                    return;
                }
                //set selected option description
                var relatedDt = $label.closest('dd').prevAll('dt:first');
                var selectedSpan = relatedDt.find("span");

                if (!selectedSpan.length) {//create span for first time use
                    selectedSpan = $("<span></span>");
                    relatedDt.append(selectedSpan);
                }
                selectedSpan.text($input.data('label'));
            });

            this._container.on('mouseleave', 'dd label', function (e) {
                var $label = $(this);
                var $selectedInput = $('> input:checked', $(this).siblings());

                if ($selectedInput.length > 0) {
                    //set selected option description
                    var relatedDt = $label.closest('dd').prevAll('dt:first');
                    var selectedSpan = relatedDt.find("span");
                    if (!selectedSpan.length) { //create span for first time use
                        selectedSpan = $("<span></span>");
                        relatedDt.append(selectedSpan);
                    }
                    selectedSpan.text($selectedInput.data('label'));
                }
            });
        }

        //Prevent variant flyout from triggered variant selection
        this._container.on('click', '.small-options label .flyout', function (e) {
            e.preventDefault();//by default children on label will trigger input on it, so prevent that.
        });

        //handle group selection
        this._container.on('click keydown', '.variant-group-tab-items label', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
                return;
            }

            var relatedDt = $(this).closest('dd').siblings('dt');
            var selectedLabel = relatedDt.find("label.product-option-label");
            var selectedGroupLabel = $(this).closest('dd').siblings('dt:first').find('> label');

            if (selectedLabel.text().length == 0) {
                selectedLabel.text(selectedLabel.data('text'));
                selectedLabel.addClass(selectedLabel.data('class'));
                selectedLabel.show();
            }

            selectedGroupLabel.removeClass('inline-error');
            $('div[class*="errors"]').remove();

            $('> label', $(this).parent().siblings()).removeClass('checked-selected');
            $('> label', $(this).parent().siblings()).removeClass('waitlisted-selected');

            if ($(this).hasClass('waitlisted')) {
                $(this).addClass('waitlisted-selected');
            }
            else {
                $(this).addClass('checked-selected');
            }

            $('> input', this).prop('checked', true);

            __scope._isPlusSizeVariantSelected = $('> input', this).data('is-plus-size-group');

            //clear out size variant selected
            var sizeVariantLabel = __scope.GetSelectedVariant('S');
            if (sizeVariantLabel) {
                var $input = $(sizeVariantLabel).find('> input');
                var selectedInputGroup = $input.attr('name');
                var selectedInputGroupNumber = selectedInputGroup.substr(21, 1) - 1;
                delete __scope.__varSelections[selectedInputGroupNumber];
                __scope.DeactivateOptionLabel(sizeVariantLabel);
            }

            //reactivate non size variant buttons
            $.each(__scope.__varSelections, function (index, label) {
                if (!label || label === sizeVariantLabel) {
                    return;
                }
                var $input = $(label).find('> input');
                __scope.SelectVariant($input.val(), false);
            });

        });

        //handle input selection
        this._container.on('change', 'input[name^="product-modal-option"]', function (e) {
            var hasMatrix = $('.matrix-options', __scope._container).length;

            if (__scope._variants === null && hasMatrix) {
                var hasMatrixErrorMessage = $('dt:first label .matrix-selection-error', __scope._container).length;
                if (!hasMatrixErrorMessage) {
                    $('dt:first label', __scope._container).append('<span class="matrix-selection-error">Please ' + $('dt:first label', __scope._container).html().toLowerCase() + ' first.</span>');
                }
                return;
            }

            var $selectedInput = $(this);

            //input group
            var selectedInputGroup = $selectedInput.attr('name');
            var selectedInputLabel = $selectedInput.parent('label');

            var selectedInputGroupNumber = selectedInputGroup.substr(21, 1) - 1;

            //clear previously selected option
            if (__scope.__varSelections[selectedInputGroupNumber] != null && __scope.__varSelections[selectedInputGroupNumber].find('> input').val() != $selectedInput.val()) {
                __scope.DeactivateOptionLabel(__scope.__varSelections[selectedInputGroupNumber]);
            }

            //set new currently selected option in this group
            __scope.__varSelections[selectedInputGroupNumber] = selectedInputLabel;

            //activate selected item
            $("input[name^='product-modal-option']:checked", __scope._container).each(function () {
                __scope.ActivateOptionLabel($(this).parent('label'), false);//TODO FIXME Hack needed after removing mouseenter/mouseleave events
                __scope.ActivateOptionLabel($(this).parent('label'), true);
            });

            $.each(_flyouts, function () {//remove previous flyouts
                __scope._application.FlyoutManager.Remove(this);
            });

            _flyouts = [];
            _flyouts.push(new HSN.Flyout({
                cacheable: true,
                closer: '<div></div>',
                flyout: $('.flyout', waitlistFlyout.clone()),
                trigger: $('.small-options label.waitlisted', __scope._container),
                noajax: false,
                relocateFlyout: true,
                timeout: 0,
                disableHover: Modernizr.touchevents
            }));
            _flyouts.push(new HSN.Flyout({
                cacheable: true,
                closer: '<div></div>',
                flyout: $('.flyout', soldoutFlyout.clone()),
                trigger: $('.small-options label.disabled-overlay', __scope._container),
                noajax: false,
                relocateFlyout: true,
                timeout: 0,
                disableHover: Modernizr.touchevents
            }));

            $.each(_flyouts, function () {//add new flyouts
                __scope._application.FlyoutManager.Add(this);
                if (Modernizr.touchevents) {
                    //On touch devices, open bubble for item selected if matches bubble trigger
                    if (selectedInputLabel.is(this.Trigger)) {
                        this.Open(selectedInputLabel);
                    }
                }
            });

        });

        //handle mouseover thumbnails
        $('.product-option-selector .inline-image', this._container).on('mouseenter', function () {
            var $input = $(this).siblings('input');
            var images = $input.data('images');

                
            if (this._isPlusSizeVariantSelected) {
                if (images.detailPlusSize) {
                    $('#new-prod-image', this._imageContainer).attr('src', images.detailPlusSize);
                }
                else if (images.zoomPlusSize) {
                    $('a', this._imageContainer).data('zoom', images.zoomPlusSize);
                }
            }
            else {
                if (images.detail) {
                    $('#new-prod-image', this._imageContainer).attr('src', images.detail);
                }
                else if (images.zoom) {
                    $('a', this._imageContainer).data('zoom', images.zoom);
                }
            }
        });

        //If only option, select it by default
        if ($('input[class*="product-modal-option-1"]', __scope._container).length == 1)
            $('input[class*="product-modal-option-1"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-2"]', __scope._container).length == 1)
            $('input[class*="product-modal-option-2"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-3"]', __scope._container).length == 1)
            $('input[class*="product-modal-option-3"]', __scope._container).first().click();

        __scope.SelectCodesFromVariant(__scope._preselectedVariant, ["S", "C"]);

    };
};

HSN.ExchangeVariantSelector.prototype =
{
    _container: null,

    /**
        * HSN.ExchangeVariantSelector#ActivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that
        *   will ultimately resolve one of the option labels in this product modal.
        * - sel (boolean) mark as selected?
        *
        * Modifies the label as necessary to support the activated state of the alternate image and
        * adds the active class.
        **/
    ActivateOptionLabel: function (label, sel) {
        var scope = this;
        var variants = scope._variants;

        if (variants === null) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label);//input for label

        //disable error messages
        $('label[class*="inline-error"]', scope._container).removeClass('inline-error');
        $('div[class*="errors"]').remove();
        $('.extended-delivery-notice', scope._container).remove();
        var errorDiv = $(scope._container).siblings('.product-modal-option-status');
        errorDiv.text('');
        var allInputs = $('input[name^="product-modal-option"]', scope._container);

        if (sel) {//mark as selected
            if ($label.hasClass('waitlisted')) {
                $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('waitlist-disabled-overlay');
                $(allInputs[i]).parent('label').addClass('waitlist-disabled-overlay')
                    .removeClass('regular')
                    .removeClass('checked-selected')
                    .removeClass('checked')
                    .removeClass('waitlisted')
                    .removeClass('waitlisted-selected');
                $(allInputs[i]).prop('checked', false);
            }
            else {
                $label.addClass('regular');
                $label.addClass('checked-selected');
            }
        }
        else {//marked as active but not selected
            $label.addClass('checked');
        }


        var selectedCode = $input.val();//variant code
            
        var inputGroupName = $input.attr('name');//radio group name of selected option
        var variantsLength = variants.length;

        if (sel && selectedCode.substr(0, 1) === "S") { //Handle Size Variant)
            scope._isPlusSizeVariantSelected = $input.data('is-plus-size-code');
        }

        var allInputsLength = allInputs.length;
        for (var i = 0; i < allInputsLength; i++) {

            if (allInputs[i].name == inputGroupName) { //if this input part of chosen input group
                if (variants[0].Codes.length > 1)
                    continue;//continue if more than one option group
                else { //only one option group exist
                    var currentCode = allInputs[i].value; //this inputs variant code
                    var foundCallout = false;
                    for (var a = 0; a < variantsLength; a++) {
                        if (jQuery.inArray(selectedCode, variants[a].Codes) > -1
                            && selectedCode == currentCode) { //if found selected variant
                            if (variants[a].Callout != null) { //if variant has callout
                                if (variants[a].Callout["Name"] == 'SoldOut'
                                    || variants[a].Callout["Name"] == 'Waitlist'
                                    || variants[a].Callout["Name"] == 'LowInventory'
                                    || variants[a].Callout["Name"] == 'BackOrder'
                                    || variants[a].Callout["Name"] == 'ExtendedDelivery') {
                                    foundCallout = true; //found selected variant, and it has callout
                                    break;
                                }
                            }
                        }
                    }
                    if (foundCallout) { //if found selected variant with callout
                        if (variants[a].Callout["Name"] == 'Waitlist') {
                                
                            $(allInputs[i]).parent('label').addClass('waitlisted');
                            $(allInputs[i]).parent('label').addClass('waitlist-disabled-overlay');

                        } else if (variants[a].Callout["Name"] == "BackOrder") {
                            $('.extended-delivery-notice', scope._container).remove();
                            var notice = $('<div class="extended-delivery-notice">Extended Delivery</div>');
                            $('.button-cancel', scope._container).before(notice);
                        }
                        else {
                            $('.extended-delivery-notice', scope._container).remove();
                        }
                    }
                }
            }
            else { //this input not in chosen input group
                var currentCode = allInputs[i].value; //this inputs variant code
                var foundVariant = false;
                for (var j = 0; j < variantsLength; j++) {
                    //if this variant group has selected variant and current input variant
                    if (jQuery.inArray(selectedCode, variants[j].Codes) > -1
                        && jQuery.inArray(currentCode, variants[j].Codes) > -1) {
                        foundVariant = true;
                        //if this variant group has callout
                        if (variants[j].Callout != null) {
                            if (variants[j].Callout["Name"] == 'SoldOut' || variants[j].Callout["Name"] == 'Waitlist') {
                                var webid = variants[j].WebId;
                                var soldout = true;
                                if (variants[0].Codes.length > 2) {
                                    //check soldout for case of 3 option groups
                                    for (var x = 0; x < variantsLength; x++) {
                                        if (variants[x].WebId != webid
                                            && jQuery.inArray(selectedCode, variants[x].Codes) > -1
                                            && jQuery.inArray(currentCode, variants[x].Codes) > -1
                                            && (variants[x].Callout == null
                                                || variants[x].Callout["Name"] != 'SoldOut' || variants[j].Callout["Name"] != 'Waitlist')) {
                                            soldout = false; //found a variant group where not sold out
                                        }
                                    }
                                }
                                if (soldout) {
                                    $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('disabled-overlay');
                                    $(allInputs[i]).parent('label').addClass('disabled-overlay')
                                        .removeClass('checked-selected')
                                        .removeClass('waitlist-disabled-overlay')
                                        .removeClass('checked')
                                        .removeClass('waitlisted-selected');
                                    if (sel) {
                                        $(allInputs[i]).prop('checked', false);
                                    }
                                }
                            }
/*                                else if (variants[j].Callout["Name"] == 'Waitlist') {
                                var waitwebid = variants[j].WebId;
                                var waitlisted = true;
                                //check waitlist for case of 3 option groups
                                if (variants[0].Codes.length > 2) {
                                    for (var z = 0; z < variantsLength; z++) {
                                        if (variants[z].WebId != waitwebid
                                            && jQuery.inArray(selectedCode, variants[z].Codes) > -1
                                            && jQuery.inArray(currentCode, variants[z].Codes) > -1) {
                                            if (variants[z].Callout == null || variants[z].Callout["Name"] != 'Waitlist') {
                                                waitlisted = false;
                                            }
                                        }
                                    }
                                }
                                if (waitlisted) {
                                    if (sel && $(allInputs[i]).parent('label').hasClass('checked')) {
                                        $(allInputs[i]).parent('label').addClass('waitlisted-selected');
                                    }
                                    else {
                                        $(allInputs[i]).parent('label').addClass('waitlisted');
                                    }
                                }
                            }*/
                            break;
                        }
                    }
                }
                if (!foundVariant) {
                    //If variant for selected combo doesnt exist, mark as soldout
                    $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('disabled-overlay');

                    $(allInputs[i]).parent('label').addClass('disabled-overlay')
                        .removeClass('checked-selected')
                        .removeClass('checked')
                        .removeClass('waitlisted-selected')
                        .removeClass('waitlist-disabled-overlay');

                    if (sel) {
                        $(allInputs[i]).prop('checked', false);
                    }
                }
            }
        }

        var statusText = "";
        if (variants != null) {
            //get currently selected values
            //TODO: reselecting vs using varSelections array
            var var1 = $("input[name='product-modal-option-1']:checked", scope._container).val();
            var var2 = $("input[name='product-modal-option-2']:checked", scope._container).val();
            var var3 = $("input[name='product-modal-option-3']:checked", scope._container).val();
            var arr = [];
            if (var1 != null)
                arr.push(var1);

            if (var2 != null)
                arr.push(var2);

            if (var3 != null)
                arr.push(var3);

            var selectedVariant = $.grep(variants || [], function (variant) {
                return ($(arr).not(variant.Codes).length == 0
                    && $(variant.Codes).not(arr).length == 0);
            });
        }

        //actually set status text
        var statusDiv = $(scope._container).siblings('.product-modal-option-status');
        statusDiv.text(statusText);

        //set selected option description
        var relatedDt = $label.closest('dd').prev('dt');
        var selectedSpan = relatedDt.find("span");
        if (!selectedSpan.length) {//create span for first time use
            selectedSpan = $("<span></span>");
            relatedDt.append(selectedSpan);
        }
        selectedSpan.text($input.data('label'));

        //Pop waitlist banner if selected product is waitlisted
/*            if (statusText == 'On Waitlist') {
            var banner = $('#modal-banner');
            var bannerH = banner.children('h6');
            banner.removeClass('none');
            banner.addClass('waitlist');
            bannerH.text('WAITLIST');
        }*/

        //if(sel) {
        //    scope.SynchronizeOptionGroupLabels();
        //}

        //Check if modal is in 'edit bag' and change Update button to waitlist.
/*            var span = $('form>div.button-group>span.add-to-bag-proxy');
        var input = $('form>div.button-group>input.add-to-bag');
        var waitlistInfo = $('.edit-item-waitlist-off');
        if (input.data('update-bag') && statusText == 'On Waitlist') {
            span.text("join waitlist");
            waitlistInfo.removeClass('edit-item-waitlist-off');
            waitlistInfo.addClass('edit-item-waitlist-on');
            statusDiv.text('');
        }*/
    },

    /**
        * HSN.ExchangeVariantSelector#DeactivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *   ultimately resolve one of the option labels in this product modal.
        *
        * Deactivate label and set description text to currently selected option.
        * Clean all labels, spans and status text
        **/
    DeactivateOptionLabel: function (label) {
        var scope = this;

        if (!scope._variants || !label) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label);//input corresponding to label
        $input.prop('checked', false);
        $label.removeClass('checked');// deactivate label

        //clean status classes from all input labels
        var allInputLabels = $('input[name^="product-modal-option"]', scope._container).parent('label');
        allInputLabels.removeClass('regular')
            .removeClass('waitlisted')
            .removeClass('disabled')
            .removeClass('waitlisted-selected')
            .removeClass('checked-selected')
            .removeClass('disabled-overlay')
            .removeClass('waitlist-disabled-overlay')
            .removeClass('variant-soldout');

        //clean all disabled-overlay spans
        var allSpans = $('span[class*="disabled-overlay"]', scope._container);
        allSpans.removeClass('disabled-overlay');
        allSpans.removeClass('waitlist-disabled-overlay');

        //clear status text
        var statusDiv = $('.product-modal-option-status', scope._container);
        statusDiv.text('');

        //populate input group description to selected or empty if no selected
        var checkedOption = $('input[name="' + $input.attr('name') + '"]:checked', scope._container);
        var checkOptionDataLabel = checkedOption.data('label') || '';
        $label.closest('dd').prev('dt').find('span').text(checkOptionDataLabel);

        //remove waitlist banner
        var banner = $('#modal-banner');
        banner.removeClass('waitlist');
        banner.addClass('none');

        //Check if modal is in 'edit bag' change back to update my bag.
        var span = $('form>div.button-group>span.add-to-bag-proxy');
        var input = $('form>div.button-group>input.add-to-bag');
        var waitlistInfo = $('.edit-item-waitlist-on');
        if (input.data('update-bag')) {
            span.text("update bag");
            waitlistInfo.removeClass('edit-item-waitlist-on');
            waitlistInfo.addClass('edit-item-waitlist-off');
        }
    },

    /**
        * HSN.ExchangeVariantSelector#SynchronizeOptionLabels() -> void
        *
        * Ensures that the selected and disabled states of the progressively enhanced option labels match
        * their associated radio buttons.
        **/
    SynchronizeOptionLabels: function () {
        var scope = this;

        if (scope._variants === null) {
            return;
        }

        var allInputs = $('input[name^="product-modal-option"]', scope.container);

        allInputs.each(function () {
            var $this = $(this);
            var $label = $this.parent('label');

            //if input disabled, add disabled class to label
            $label[$this.prop('disabled') ? 'addClass' : 'removeClass']('disabled');

            if ($this.prop('disabled')) {//TODO is input ever disabled?
                var inputCousins = $label.siblings('label').children('input[class*="' + $this.attr('name') + '"]');
                inputCousins.each(function () {
                    var $cousinLabel = $(this);

                    var $labelOverlay = $cousinLabel.find('.disabled-overlay');
                    if (!$labelOverlay.length) {
                        $labelOverlay = $('<div class="disabled-overlay"></div>');
                        $cousinLabel.append($labelOverlay);
                    }
                });
            }
            //if active, add checked class
            $label[$this.prop('checked') ? 'addClass' : 'removeClass']('checked');
        });
    },

    /**
    *HSN.ExchangeVariantSelector.SynchronizeOptionGroupLabels() -> void
    *
    *Adds visual overlays to option groups based on group children
    **/
    SynchronizeOptionGroupLabels: function () {
        var scope = this;

        var variantTypes = $('> dl > dd.variant-group-tab-items', this._container).parent();

        $.each(variantTypes, function () {
            var variantType = this;
            var optionGroups = $('> dd.small-options', this);
            $.each(optionGroups, function () {
                var options = $('> label', this);
                var optionsGroupLabel = $('> dd.variant-group-tab-items a[href$="' + $(this).prop('id') + '"] > label', variantType);
                if (options.length === options.filter('.disabled-overlay').length) {
                    optionsGroupLabel.addClass('disabled-overlay');
                }
                else {
                    optionsGroupLabel.removeClass('disabled-overlay');
                }
                if (options.length === options.filter('.waitlisted').length) {
                    optionsGroupLabel.addClass('waitlisted');
                }
                else {
                    optionsGroupLabel.removeClass('waitlisted');
                }
            });
        });
    },

    SelectVariant: function (variantCode, selectOnlyGroup) {
        var scope = this;

        var $sizeVariantInput = $('input[value="' + variantCode + '"]', scope._container);
        var $sizeGroup = $sizeVariantInput.closest('dd');
        var $sizeGroupTab = $('a[href="#' + $sizeGroup.prop('id') + '"] > label', $sizeGroup.parent());

        $sizeGroupTab.click();
        if (!selectOnlyGroup && $sizeVariantInput) {
            $sizeVariantInput.click();
            $sizeVariantInput.change();
        }
    },

    IsPlusSizeGroupSelected: function () {
        return this._isPlusSizeVariantSelected;
    },

    GetSelectedVariant: function (variantType) {
        if (!variantType) {
            return false;
        }

        var scope = this;

        return $.grep(scope.__varSelections, function (variantLabel) {
            if (variantLabel) {
                var $input = variantLabel.find('> input');
                return $input.val().substr(0, 1) === variantType;
            }
            return false;
        })[0];//should only have single result
    },

    GetSelectedSku: function () {

        var id = -1;

        var allErrors = [];
        var scope = this;
        var inputLabels = $("label.required-selection", scope._container);
        var arr = [];

/*            var selectedVariant = this.GetSelectedVariant();
        if(selectedVariant.Callout && selectedVariant.Callout["Name"] == 'Waitlist') {
            return false;
        }*/

        $.each(inputLabels, function () {
            var inputLabel = $(this);
            var checkedInput = $('input[name="' + $(this).data('selection-name') + '"]:checked', scope._container);
            if (checkedInput.length === 0) {
                var labelText = inputLabel.text().toLowerCase();
                if (labelText.length) {
                    allErrors.push('Please select a ' + labelText);
                    inputLabel.addClass('inline-error');
                }
            }
            else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                arr.push(checkedInput.val());
            }
        });

        var allErrorsLength = allErrors.length;
        if (allErrorsLength > 0) {
            var $errors = $('<div class="errors-exchange"><div class="add"></div></div>');

            for (var i = 0; i < allErrorsLength; i++) {
                if (allErrors[i] != null) {
                    $errors.find('div.add').append('<div>' + allErrors[i] + '</div>');
                }
            }
            $('div.errors-exchange', scope._container).remove();
            $('.exchange-notice', scope._container).after($errors);
            $(this).focus();
            $('.product-modal-option-status', scope._container).last().text('');
            return false;
        }

        var isWaitlist = false;

        jQuery.each(scope._variants, function (k, v) {
            if ($(arr).not(v.Codes).length == 0 && $(v.Codes).not(arr).length == 0) {
                id = v.Sku;

                if(v.Callout != null && v.Callout["Name"] == "Waitlist") {
                    isWaitlist = true;
                }
                return;
            }
        });

        if (isWaitlist) {
            $('div.errors-exchange', scope._container).remove();
            var $waitlisterror = $('<div class="errors-exchange"><div class="add"><div style="font-size: 90%;">We are unable to complete an exchange for an item on waitlist.</div></div></div>');
            $('.exchange-notice', scope._container).after($waitlisterror);
            return false;
        }
            
        $('#selectedSku').val(id);

        return true;

    },

    SelectCodesFromVariant: function (variant, variantTypes) {
        if (!variant) {
            return;
        }

        var scope = this;

        var codes = $.grep(variant.Codes || [], function (code) {
            var codeType = code.substr(0, 1);
            return !variantTypes || $.inArray(codeType, variantTypes) !== -1;
        });

        $.each(codes, function () {
            var codeType = this.substr(0, 1);
            if (codeType === "S") {//Handle Size Variant
                scope.SelectVariant(this, true);
            }
            else {
                scope.SelectVariant(this, false);
            }
        });
    }
};

/**
    * HSN.ExchangeVariantSelector.EVENT = Object
    *
    * An enumeration of events an [[HSN.Flyout]] can raise:
    * - OPTION_CHANGED: Fires when an option selection changes.
    **/
HSN.ExchangeVariantSelector.EVENT =
{
    OPTION_CHANGED: 'HSN.ExchangeVariantSelector:OPTION_CHANGED'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Exchange/ExchangeVariantSelector.js